import React, { useState, useRef, FormEvent } from 'react';
import { Form, Button } from 'react-bootstrap';
import SignatureCanvas from 'react-signature-canvas';
import { IVisitorAgreementStepProps } from './types';
import useStepper from '../../../stepper/useStepper';
import styles from './VisitorAgreementStep.module.css';
import { StepperButtons } from '../../../stepper/buttons';

// https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/content-styles.html#the-full-list-of-content-styles
const VisitorAgreementStep: React.FC<IVisitorAgreementStepProps> = ({
  content,
  useDigitalSignature,
  onChangedDigitalSignature,
}) => {
  const { onFinish } = useStepper();

  const signatureElement = useRef<SignatureCanvas>(null);
  const [agreed, setAgreed] = useState<boolean>(false);
  const [showErrors, setShowErrors] = useState<boolean>(false);

  const handleSignatureAdded = () => {
    if (!signatureElement.current) return;

    onChangedDigitalSignature(
      signatureElement.current.getTrimmedCanvas().toDataURL(),
    );

    setAgreed(true);
    setShowErrors(false);
  };

  const clearSignature = () => {
    signatureElement.current!.clear();
    setAgreed(false);
    onChangedDigitalSignature('');
  };

  const handleAgreeChange = (event: FormEvent<HTMLInputElement>) => {
    setAgreed(event.currentTarget.checked);
    setShowErrors(!event.currentTarget.checked);
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (agreed) {
      onFinish();
    } else {
      setShowErrors(true);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div
        className="ck-content"
        dangerouslySetInnerHTML={{ __html: content }}
      />
      {useDigitalSignature ? (
        <div>
          {showErrors && (
            <div className="text-danger text-center">
              Please sign the agreement
            </div>
          )}
          <SignatureCanvas
            ref={signatureElement}
            penColor="black"
            canvasProps={{ className: `${styles.signature}` }}
            onEnd={handleSignatureAdded}
          />
          <Form.Text className="text-muted text-center my-2">
            Please add your signature using your finger or the provided pen
          </Form.Text>
          <div className={styles.signatureButtonContainer}>
            <Button type="button" size="sm" onClick={clearSignature}>
              Clear Signature
            </Button>
          </div>
        </div>
      ) : (
        <>
          {showErrors && (
            <div className="text-danger text-center">
              Please acknowledge the agreement
            </div>
          )}
          <Form.Group controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              label="I Agree"
              onChange={handleAgreeChange}
            />
          </Form.Group>
        </>
      )}
      <StepperButtons submitMode finishLabel="Sign In" />
    </form>
  );
};

export default VisitorAgreementStep;
